<app-organizer-shared-layout-dashboard [hasHeader]="hasHeader">
  <app-organizer-shared-header
    class="col-span-12 mb-4 lg:col-span-6 lg:mb-3"
    [title]="
      'organizer.timeslot.pre_schedule.group_size.page.title' | translate
    "
    [backLink]="backLink"
    [backLinkAriaLabel]="
      'a11y.organizer.timeslot.pre_schedule.group_size.page.title' | translate
    "
  ></app-organizer-shared-header>

  <div class="col-span-12 lg:col-span-5 lg:col-start-2">
    <form (ngSubmit)="submit()">
      <app-form-input-group
        [label]="
          'organizer.timeslot.pre_schedule.group_size.input.label' | translate
        "
        [errors]="errors"
        errorKey="group_size"
      >
        <app-form-input
          #content
          [formControl]="groupSize"
          [placeholder]="
            'organizer.timeslot.pre_schedule.group_size.input.placeholder'
              | translate
          "
          [type]="inputType"
        ></app-form-input>
      </app-form-input-group>

      <button
        app-vtmn-play-button
        type="submit"
        [type]="ctaButtonType.Submit"
        class="self-start w-full mt-4 md:w-auto"
        [disabled]="hasErrors ? true : null"
        [attr.data-disabled]="hasErrors ? true : null"
      >
        {{ 'organizer.edit_field.button.save' | translate }}
      </button>
    </form>
  </div>
</app-organizer-shared-layout-dashboard>
